import { RealisationHourtype } from './classes/realisation';
import { FieldTemplate } from './components/fields-template/field-template';
import { EntityType } from './services/entities/entity-type.class';
import { Address } from './services/location.service';

export interface HourTypeOption {
    value: RealisationHourtype;
    label: string;
    sortOrder?: number;
}

export enum PeriodType {
    FourWeeks = '4weeks',
    Month = 'month',
}

export type PLATFORM = 'trackline' | 'dvds' | 'buitengewoonbv';

export interface Environment {
    // Alow additional properties of any type
    [key: string]: any;
    dirkAppUrl?: string;
    allowWorksWith: boolean;
    apiEndpoint: string;
    appTitle: string;
    asphaltPlanning: boolean;
    checkHoursBundle: 'afas_project_id' | 'planning_id';
    companyAddress: Address;
    dayReportPlanning: boolean;
    defaultStand: boolean;
    disableAfas: boolean;
    employeeEmployees: boolean;
    employeePlanning: boolean;
    enableDayreport: boolean;
    entitytypes: Record<string, EntityType>;
    entitytypeTemplates: Record<string, FieldTemplate> | null;
    executorName: string;
    executorNamePlural: string;
    executorPlanning: boolean;
    executors: any[];
    feEndpoint: string;
    fromEmail: string;
    inventarizePlanning: boolean;
    leaveHourTypes: HourTypeOption[];
    limitFutureOwnPlanningOverview?: boolean;
    microsoftLogin: boolean;
    microsoftLoginRequired?: boolean;
    name: string;
    officePhoneNumber: string;
    onlyAddRealisationOnPlanning: boolean;
    onlyOvertime: boolean;
    orderDirect: boolean;
    /** Kent dit platform deelprojecten onder een hoofdproject? Zo niet, dan maakt de projectdialog hoofdprojecten aan. */
    subProjects: boolean;
    /** Gebruiken we maandelijks of vier-wekelijks voor periodeverrekening: {@link PeriodType} */
    periodType: PeriodType;
    /** Welke kolommen moeten worden weergegeven in de periodeverrekening */
    periodSettlementColums: {
        '135V': boolean;
        '145V': boolean;
        '200V': boolean;
        100: boolean;
        125: boolean;
        135: boolean;
        145: boolean;
        150: boolean;
        200: boolean;
        '200Z': boolean;
        Z: boolean;
    };
    planningEntityTypes?: EntityType[];
    /** Welke platform draait er: {@link PLATFORM} */
    platform: PLATFORM;
    /** Draait de applicatie in een productieomgeving */
    production: boolean;
    projectIdentifier: RegExp;
    projectmanager: any;
    /**
     * Enables the public, unauthenticated ticket ("melding indienen") form and its
     * login-screen link. Meant as a single, company-wide intake point (DvdS), not per subsidiary.
     */
    publicTicketForm?: boolean;
    realisationHourTypes?: HourTypeOption[];
    roles: Readonly<Record<string, string>>;
    rootPage: string;
    rootPageName: string;
    shortName: string;
    status: Readonly<Record<string, Record<string, string>>>;
    test: boolean;
    titleAppend: string;
    transportPlanning: boolean;
    travelTime: boolean;
    vkmPlanning: boolean;
    weekPlanning: boolean;
    weekPlanningEmployees: any[];
    weekScheduleComponent?: 'planning' | 'realisations';
    wsEndpoint: string;
}
